module.exports = __webpack_public_path__ + "static/media/default-avatar-female.1bae3484.png";